import { MDBAlert, MDBBtn, MDBInput, MDBModalBody, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useState } from "react";
import { addOrganization } from "../../../apiclients/streamsapi_bridge";
import { useLocation, useNavigate } from "react-router";

export default function NewOrg(props){

    
    const[orgName, setOrgName] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const [internalError, setInternalError] = useState(false);
    const [isloading, setIsloading] = useState(false);
    
    const navigate = useNavigate();
    

    async function addOrg(event){
        try{
            setErrorMessage(null);
            event.preventDefault();
            event.stopPropagation();       
            if(!orgName || orgName.trim().length == 0){
                setErrorMessage(`Organization Name cannot be empty`);
                return;
            }  
            const ORG_NAME_REGEX = /^.{1,100}$/;
            if (!ORG_NAME_REGEX.test(orgName)) {
                setErrorMessage(`The Org Name is invalid. It must not exceed a maximum number of 100 characters.`);
                return;
            }
            setIsloading(true);
            //sending add request.
            let apiResponse = await addOrganization(JSON.parse(sessionStorage.getItem("admin_session")).siteid, orgName);
            setTimeout(() => { setIsloading(false) }, 1000);
            if(apiResponse.status == 200){
                let apiData = await apiResponse.json();
                localStorage.setItem("s_message",apiData.message);
                // console.log("fueiwhfuef "+apiData.message+" tab1")
                navigate(".", {
                    state: {
                        tab1: "tab1"
                    }
                });
                window.location.href = "/orggroupslandingpage";
                props.onClose();
            }else if(apiResponse.status == 400){
                let apiErroData = await apiResponse.json();
                setErrorMessage(apiErroData.message?.errors[0]?.message ?? null);
            } else{
                setInternalError(true);
            }
            
        }catch(error){
            console.log(`Unable to add organizations :${error}`);
            setInternalError(true);
        }
    }

    return (
        <>

            <MDBModalBody>
                <div class="fw-500">Org Name</div>
                <div className="w-100 mt-2">
                    <MDBInput maxLength={100} size="sm" onChange={(e)=>{e.stopPropagation();e.preventDefault(); setOrgName(e.target.value);setErrorMessage("")} }  />
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </div>
            </MDBModalBody>

            <MDBModalFooter>
                <MDBBtn color='secondary' onClick={props.onClose}>
                    Cancel
                </MDBBtn>
                <MDBBtn onClick={(e)=> addOrg(e)}>Add</MDBBtn>
            </MDBModalFooter>
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="top-center"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
            {isloading && (
              <>
                  <div className="loadingclass">
                      <MDBBtn disabled>
                          <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                          Loading...
                      </MDBBtn>
                  </div>
              </>
          )}
        </>
    );

}